/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

const INIT = { driverId: "", driverName: "", month: "", deductionType: "", amount: "", reason: "" };

export default function EmployeeDeduction() {
  const [form, setForm]       = useState(INIT);
  const [records, setRecords] = useState([]);
  const [search, setSearch]   = useState("");
  const [loading, setLoading] = useState(false);
  const [saved, setSaved]     = useState(false);
  const [error, setError]     = useState("");

  const fetchDeductions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/advance/deductions`);
      setRecords(res.data || []);
    } catch (e) { setRecords([]); }
    setLoading(false);
  };

  useEffect(() => { fetchDeductions(); }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.driverId.trim() || !form.amount) { setError("Driver ID and Amount are required."); return; }
    setError("");
    try {
      await axios.post(`${API_BASE_URL}/advance/deductions`, form);
      setForm(INIT); setSaved(true);
      setTimeout(() => setSaved(false), 3000);
      fetchDeductions();
    } catch (err) { setError(err.response?.data?.message || "Submission failed"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this deduction?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/advance/deductions/${id}`);
      fetchDeductions();
    } catch (e) { alert("Delete failed"); }
  };

  const filtered = records.filter(r =>
    (r.driverId || "").toLowerCase().includes(search.toLowerCase()) ||
    (r.driverName || "").toLowerCase().includes(search.toLowerCase())
  );

  const S = {
    container:  { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    body:       { padding: "20px" },
    card:       { background: "#fff", border: "1px solid #000", borderRadius: 8, padding: "16px 18px", marginBottom: 16, maxWidth: 700 },
    cardTitle:  { fontWeight: "bold", fontSize: 14, marginBottom: 14 },
    grid:       { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginBottom: 14 },
    label:      { fontSize: 12, fontWeight: "bold", marginBottom: 4, display: "block" },
    input:      { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, width: "100%", boxSizing: "border-box" },
    select:     { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, background: "#fff", width: "100%", boxSizing: "border-box" },
    textarea:   { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, width: "100%", boxSizing: "border-box", minHeight: 60, resize: "vertical" },
    btnRow:     { display: "flex", gap: 10, marginTop: 10 },
    btnYellow:  { background: "#FFC107", color: "#000", border: "none", padding: "10px 24px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:   { background: "#000", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    success:    { background: "#e6f9ee", border: "1px solid #27ae60", color: "#27ae60", padding: "10px", borderRadius: 6, marginTop: 12, fontSize: 13 },
    errBox:     { background: "#fde8e8", border: "1px solid #c0392b", color: "#c0392b", padding: "10px", borderRadius: 6, marginTop: 12, fontSize: 13 },
    toolbar:    { display: "flex", gap: 10, alignItems: "center", marginBottom: 12 },
    table:      { width: "100%", borderCollapse: "collapse" },
    thB:        { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:         { border: "1px solid #ccc", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Employee Deduction</h2>
      <div style={S.body}>

        {/* Form */}
        <div style={S.card}>
          <div style={S.cardTitle}>Add Deduction</div>
          <form onSubmit={handleSubmit}>
            <div style={S.grid}>
              <div>
                <label style={S.label}>Driver ID *</label>
                <input style={S.input} name="driverId" placeholder="e.g. DE0001" value={form.driverId} onChange={handleChange} required />
              </div>
              <div>
                <label style={S.label}>Driver Name</label>
                <input style={S.input} name="driverName" placeholder="Driver name" value={form.driverName} onChange={handleChange} />
              </div>
              <div>
                <label style={S.label}>Month</label>
                <input style={S.input} type="month" name="month" value={form.month} onChange={handleChange} />
              </div>
              <div>
                <label style={S.label}>Deduction Type</label>
                <select style={S.select} name="deductionType" value={form.deductionType} onChange={handleChange}>
                  <option value="">-- Select Type --</option>
                  <option>Late Fine</option>
                  <option>Damage</option>
                  <option>Uniform</option>
                  <option>Loan Repayment</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label style={S.label}>Amount (₹) *</label>
                <input style={S.input} type="number" name="amount" placeholder="0.00" value={form.amount} onChange={handleChange} min="0" required />
              </div>
            </div>
            <div>
              <label style={S.label}>Reason</label>
              <textarea style={S.textarea} name="reason" placeholder="Reason for deduction..." value={form.reason} onChange={handleChange} />
            </div>
            <div style={S.btnRow}>
              <button style={S.btnYellow} type="submit">✅ Save Deduction</button>
              <button style={S.btnBlack} type="button" onClick={() => { setForm(INIT); setError(""); setSaved(false); }}>🗑 Clear</button>
            </div>
          </form>
          {saved  && <div style={S.success}>✅ Deduction saved successfully!</div>}
          {error  && <div style={S.errBox}>{error}</div>}
        </div>

        {/* Table */}
        <div style={S.toolbar}>
          <input style={{ ...S.input, width: 200 }} placeholder="Search driver..." value={search} onChange={e => setSearch(e.target.value)} />
          <span style={{ fontSize: 13, color: "#555" }}>{filtered.length} records</span>
        </div>

        {loading ? (
          <p>Loading deductions...</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={S.table}>
              <thead>
                <tr>
                  {["#","Driver ID","Name","Month","Type","Amount","Reason","Action"].map(h => (
                    <th key={h} style={S.thB}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={8} style={{ ...S.td, color: "#888" }}>No deductions found</td></tr>
                ) : filtered.map((r, i) => (
                  <tr key={r._id} style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                    <td style={S.td}>{i + 1}</td>
                    <td style={S.td}>{r.driverId}</td>
                    <td style={S.td}>{r.driverName}</td>
                    <td style={S.td}>{r.month}</td>
                    <td style={S.td}>{r.deductionType}</td>
                    <td style={S.td}>₹{r.amount}</td>
                    <td style={S.td}>{r.reason || "—"}</td>
                    <td style={S.td}>
                      <button style={{ background: "#fde8e8", border: "1px solid #c0392b", color: "#c0392b", padding: "4px 10px", borderRadius: 5, cursor: "pointer", fontSize: 12 }}
                        onClick={() => handleDelete(r._id)}>🗑 Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
